/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AprilFoolType,
    AprilFoolTypeFromJSON,
    AprilFoolTypeFromJSONTyped,
    AprilFoolTypeToJSON,
} from './AprilFoolType';

/**
 * 
 * @export
 * @interface PressRelease
 */
export interface PressRelease {
    /**
     * プレスリリースID
     * @type {number}
     * @memberof PressRelease
     */
    pressReleaseId: number;
    /**
     * 企業ID
     * @type {number}
     * @memberof PressRelease
     */
    companyId: number;
    /**
     * タイトル
     * @type {string}
     * @memberof PressRelease
     */
    title: string;
    /**
     * 企業名
     * @type {string}
     * @memberof PressRelease
     */
    companyName: string;
    /**
     * 公開日時
     * @type {string}
     * @memberof PressRelease
     */
    publishedDatetime: string;
    /**
     * 
     * @type {string}
     * @memberof PressRelease
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof PressRelease
     */
    pressReleaseUrl: string;
    /**
     * 
     * @type {AprilFoolType}
     * @memberof PressRelease
     */
    aprilFoolType: AprilFoolType;
}

export function PressReleaseFromJSON(json: any): PressRelease {
    return PressReleaseFromJSONTyped(json, false);
}

export function PressReleaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressRelease {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pressReleaseId': json['press_release_id'],
        'companyId': json['company_id'],
        'title': json['title'],
        'companyName': json['company_name'],
        'publishedDatetime': json['published_datetime'],
        'thumbnailUrl': json['thumbnail_url'],
        'pressReleaseUrl': json['press_release_url'],
        'aprilFoolType': AprilFoolTypeFromJSON(json['april_fool_type']),
    };
}

export function PressReleaseToJSON(value?: PressRelease | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'press_release_id': value.pressReleaseId,
        'company_id': value.companyId,
        'title': value.title,
        'company_name': value.companyName,
        'published_datetime': value.publishedDatetime,
        'thumbnail_url': value.thumbnailUrl,
        'press_release_url': value.pressReleaseUrl,
        'april_fool_type': AprilFoolTypeToJSON(value.aprilFoolType),
    };
}

